export default __webpack_public_path__ + "static/media/map-pinpointing-location.db2fea4c.svg";